<template>
  <div class="course_status">
    <template v-if="courseStatus === -1">
      <span>已结束</span>
    </template>
    <template v-else-if="courseStatus === 2">
      <span>未开始</span>
    </template>
    <template v-else-if="courseStatus === 1">
        <span class="status_label">距离开课</span>
        <span class="status_img">
          <img src="~assets/index_v2/icon_kebiao_shijian.png" alt="" />
        </span>
        <span class="status_text">剩余&nbsp;{{ timecountdown | formatSencond2MinuteSencond }}</span>
    </template>
    <template v-else-if="courseStatus === 0">
      <span style="display: none">进入课堂</span>
    </template>
    <template v-else-if="courseStatus === 3">
      <span>已过进入时间</span>
    </template>
  </div>
</template>

<script>
import { enterStatus } from '@/utils/format-tools'

export default {
  name: "course_status",
  components: {},
  data() {
    return {
        timer: '',
        timecountdown: this.data.timecountdown
    };
  },
  props: ["data"],
  computed: {
    courseStatus: function() {
      const {s_time, e_time } = this.data;
      const { pre_in_class, after_in_class } = this.data.config || {pre_in_class: 0, after_in_class: 0};
      return enterStatus({
        timecountdown: this.timecountdown,
        pre_in_class,
        after_in_class,
        s_time,
        e_time
      })
    }
  },
  watch: {},
  methods: {
    enterRoom (data) {
      this.$emit('enterRoom', data)
    },
    enterInterval (data) {
      this.timecountdown --
      if (this.timecountdown < 0) {
        clearInterval(this.timer)
      }
    }
  },
  created() {},
  mounted() {
    this.timer = setInterval(this.enterInterval, 1000)
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    clearInterval(this.timer)
  },
  destroyed() {},
  activated() {}
};
</script>
<style lang="less" scoped>
  .course_status{
    height: 30px;
    position: absolute;
    right: 2rem;
    top: 3rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: flex-start;
    .status_label{
      font-weight: bold;
      color: rgba(59, 164, 133, 1);
    }
    .status_text{
      color:#262626;
    }
    .status_img{
      margin: 0 1rem;
      img{
        vertical-align: baseline;
        width: 17px;
      }
    }
  }
</style>
